import React from 'react';
import styled from 'styled-components';

interface CardProps {
  title?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  expandable?: boolean;
}

const CardContainer = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  overflow: hidden;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
`;

const CardTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1A2440;
`;

const CardActions = styled.div`
  display: flex;
  gap: 10px;
`;

const CardContent = styled.div`
  padding: 20px;
`;

const Card: React.FC<CardProps> = ({ 
  title, 
  children, 
  actions,
  expandable = false
}) => {
  const [expanded, setExpanded] = React.useState(true);

  return (
    <CardContainer>
      {title && (
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          <CardActions>
            {actions}
            {expandable && (
              <button 
                onClick={() => setExpanded(!expanded)}
                style={{ 
                  background: 'none', 
                  border: 'none', 
                  cursor: 'pointer',
                  fontSize: '14px',
                  color: '#6c757d'
                }}
              >
                {expanded ? 'Hide' : 'Show More'}
              </button>
            )}
          </CardActions>
        </CardHeader>
      )}
      {(!expandable || expanded) && (
        <CardContent>
          {children}
        </CardContent>
      )}
    </CardContainer>
  );
};

export default Card;
